import { User } from "@src/gql/generated";
import { CallNotification } from "@src/types/call.types";
import { atom } from "jotai";
import { atomWithStorage } from "jotai/utils";

// DESC: Primitive Type Example
export const isCompleteProfile = atom<boolean>(false);

export const authAtom = atom<{
  isAuthenticated: boolean | null;
  user: User | null;
}>({
  isAuthenticated: null,
  user: null,
});

export const conversationsAtom = atomWithStorage<{ [id: string]: any }>(
  "chat/conversations-cache",
  {},
);

export type CallStatus =
  | "idle"
  | "ringing"
  | "accepted"
  | "rejected"
  | "missed";

export const incomingCallAtom = atom<CallNotification | null>(null);
export const outgoingCallAtom = atom<CallNotification | null>(null);
export const isRingtoneMutedAtom = atom<boolean>(false);
export const callStatusAtom = atom<CallStatus>("idle");
